import {classNames} from "shared/lib/classNames/classNames";
import cls from "./ServicesPage.module.scss";
import {ReactNode} from "react";
import {ReactComponent as BespokeIcon} from "shared/assets/icons/services/Bespoke.svg";
import {ReactComponent as MultiPlatformIcon} from "shared/assets/icons/services/MultiPlatform.svg";
import {ReactComponent as DesignIcon} from "shared/assets/icons/services/Design.svg";
import {ReactComponent as AssistanceIcon} from "shared/assets/icons/services/Assistance.svg";
import {ReactComponent as ConstructionIcon} from "shared/assets/icons/services/Construction.svg";
import {ReactComponent as EvaluationIcon} from "shared/assets/icons/services/Evaluation.svg";
import {ReactComponent as ManagementIcon} from "shared/assets/icons/services/Management.svg";
import {ReactComponent as VRIcon} from "shared/assets/icons/services/VR.svg";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import {ReactComponent} from "*.svg";

export const ServicesPage = () => {
    interface Service {
        icon: ReactNode;
        text: string;
        active?:boolean;
    }
    const services: Service[] = [
        {
            icon: <BespokeIcon />,
            text: "Bespoke iOS and Android Software Creation"
        },
        {
            icon: <MultiPlatformIcon />,
            text: "Multi-Platform Application Engineering",
            active:true,
        },
        {
            icon: <DesignIcon />,
            text: "Interface Design and Concept Visualization"
        },
        {
            icon: <AssistanceIcon />,
            text: "Application Upkeep and Client Assistance"
        },
        {
            icon: <ConstructionIcon />,
            text: "API Construction and Systems Integration"
        },
        {
            icon: <EvaluationIcon />,
            text: "Software Evaluation and Performance Validation"
        },
        {
            icon: <ManagementIcon />,
            text: "Marketplace Presence Enhancement and Launch Management"
        },
        {
            icon: <VRIcon />,
            text: "Cutting-Edge Tech Incorporation (Augmented Reality, Virtual Reality, Artificial Intelligence)"
        },
    ]
    return (
        <div id={"servicesPage"} className={classNames(cls.ServicesPage, {}, [])}>
            <section className={classNames("page-section", {}, [])}>
                <div className={classNames("container container__main")}>
                    <div className={cls.ServicesPage__services}>
                        <Title className={cls.ServicesPage__title} sentences={["Our Technical Offerings"]} colors={[TitleTheme.NEUTRAL]} />
                        <div className={cls.services}>
                            {services.map((service) => {
                                return (
                                    <div className={classNames(cls.services__item, {
                                        [cls.services__item_active]: service.active
                                    }, [])}>
                                        <div className={cls.services__icon}>
                                            {service.icon}
                                        </div>

                                        <div className={cls.services__text}>
                                            {service.text}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
};

